// packages block
import { Box, IconButton, InputAdornment, TextField } from '@mui/material'
import { FC, KeyboardEvent, useContext, useEffect, useState } from 'react'
// components block
import { CrossIcon } from '../../assets/images'
import { RoleFilter } from './RoleFilter'
// others block
import { AppContext } from '../../context/AppContext'
import { ActionType } from '../../context/AppContextReducer'
import { SearchWithSortProps } from '../../interfaceTypes'
import { SearchWithSortBox } from '../../theme/styleComponents'

export const SearchWithSort: FC<SearchWithSortProps> = ({ sortByRole, searchPlaceholder, loading }): JSX.Element => {
  const [search, setSearch] = useState<string>('')
  const { dispatch: reducerDispatch, searchValue, isLoading } = useContext(AppContext)

  const searchHandler = (event: KeyboardEvent<HTMLInputElement>) => {
    reducerDispatch({ type: ActionType.SET_SEARCH_VALUE, searchValue: search ?? undefined })
    reducerDispatch({ type: ActionType.SET_CURRENT_PAGE, currentPage: 1 })
    reducerDispatch({ type: ActionType.SET_DATE_FILTER, dateFilter: '' })
    reducerDispatch({ type: ActionType.SET_STATUS_FILTER, statusFilter: null })
    // Don't reset role filter when searching - keep current filter or search all users
  }

  const clearSearchHandler = () => {
    reducerDispatch({ type: ActionType.SET_SEARCH_VALUE, searchValue: '' })
    setSearch('')
  }

  useEffect(() => {
    setSearch(searchValue || '')
  }, [searchValue])

  return (
    <SearchWithSortBox padding={sortByRole ? '15px' : '0'}>
      <Box maxWidth={350} width="100%">
        {searchPlaceholder && (
          <TextField
            label={searchPlaceholder}
            onKeyDown={searchHandler}
            onChange={({ target: { value } }) => setSearch(value)}
            value={search}
            disabled={isLoading || loading}
            fullWidth
            size="small"
            variant="outlined"
            InputProps={{
              endAdornment:
                search && searchValue ? (
                  <InputAdornment position="end" onClick={clearSearchHandler}>
                    <IconButton
                      sx={{ p: 0, svg: { maxWidth: '10px' } }}
                      onClick={clearSearchHandler}
                      aria-label="clear search"
                    >
                      <CrossIcon />
                    </IconButton>
                  </InputAdornment>
                ) : undefined
            }}
          />
        )}
      </Box>

      {sortByRole && <RoleFilter sortByRole={sortByRole} setSearch={setSearch} loading={loading} />}
    </SearchWithSortBox>
  )
}
